import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import {PARAMETERIZER_FACTOR} from 'constants/contextual-help.js';
import {PARAMETERIZER_OFFSET} from 'constants/contextual-help.js';
import {PARAMETERIZER_DROPDOWN} from 'constants/contextual-help.js';
import {PROBABILITY} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class ParameterizerEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    getParameterOptions() {
        let parameters = this.props.effect
            .getAvailableParameters();
        return parameters.map(
            p => ({
                label: p.name,
                value: p}));
    }

    getParameterOption(o) {
        if (o === undefined) {
            return undefined;
        }
        let filtered = this.getParameterOptions().filter(
            x => x.value === o);

        return filtered.length > 0 ? filtered[0] : undefined;
    }

    handleParameterChange(p) {
        this.props.effect.parameter = p.value;
        this.setState(this.state);
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    deleteParameter() {
        this.props.deleteParameterizer(this.props.effect);
    }

    render() {
        return (
            <div className={this.props.isSimple ? "parameterizer" : ""}>
              <ConditionedComponent condition={this.isEnabled()}>
                <div
                  onMouseOver={(e) => this.setContextualHelp(e, PARAMETERIZER_DROPDOWN)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  className="parameter-dropdown-container">
                  <div className="lfo-rate-label">Parameter:</div>
                  <Dropdown
                    className='osc-type-dropdown'
                    controlClassName='osc-type-control-dropdown'
                    arrowClassName='osc-type-arrow-dropdown'
                    options={this.getParameterOptions()}
                    onChange={(o) => this.handleParameterChange(o)}
                    value={this.getParameterOption(this.props.effect.parameter)}
                    placeholder="Parameter" />
                </div>
                <div className="clear-fix"/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  contextualHelp={PARAMETERIZER_FACTOR}
                  name={'Factor'}
                  automation={this.props.automation}
                  parameter={this.props.effect.factorParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={0.01}
                  max={8}/>
                <EffectParameterSlider
                  contextualHelp={PARAMETERIZER_OFFSET}
                  effectNumber={this.props.effectNumber}
                  automation={this.props.automation}
                  name={'Offset'}
                  root={1}
                  parameter={this.props.effect.offsetParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.1}
                  min={-12}
                  max={12}/>
            {!this.props.isSimple ? 
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Probability'}
                  contextualHelp={PROBABILITY}
                  automation={this.props.automation}
                  parameter={this.props.effect.probabilityParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0}
                  max={100}/>
             : ''}
              </ConditionedComponent>
              {this.props.isSimple ?
               <div onClick={() => this.deleteParameter()} className="delete-btn">x</div> : ''}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(ParameterizerEffectComponent);
